import axios from "../../../services/axios-config.js";

// INICIA O ACESSO DE SUPORTE: A API VALIDA O ADMIN NO BANCO, GRAVA A SESSÃO E DEVOLVE A URL DE ENTRADA NO APP
// (specs/ACESSO-ADMIN-CONTA-CLIENTE.spec.md). A URL CARREGA UM TICKET DE USO ÚNICO: NÃO LOGAR, NÃO GUARDAR
export async function startSupportAccess({ userId, companyId, reason }) {
    try {
        const response = await axios.post('/support-access/start', { userId, companyId, reason });

        return response.data;

    } catch (error) {
        console.error('ERROR - START SUPPORT ACCESS SERVICE:', error?.response?.status);
        throw error;
    }
}
